<template>
  <a-config-provider :locale="local">
    <router-view />
  </a-config-provider>
</template>

<script>
// import { ConfigProvider, Space, Divider } from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale-provider/zh_CN'
import enUS from 'ant-design-vue/es/locale-provider/en_US'
import {computed, reactive} from 'vue'
import {useStore} from "vuex";
export default {
  name: 'App',
  setup(){

    const $store = useStore();

    let language = localStorage.getItem('smartAdultLanguage');

    if(!language){
      $store.commit('changeLanguage','zh_CN')
    }else {
      $store.commit('changeLanguage',language)
    }
    const local = computed(()=>{
      return $store.state.language == 'zh_CN'?zhCN:enUS
    })
    const colorState = reactive({
      primaryColor: 'red',
      errorColor: '#ff4d4f',
      warningColor: '#faad14',
      successColor: '#52c41a',
      infoColor: '#1890ff',
    });
    // const onColorChange = (type, e) => {
    //   Object.assign(colorState, {
    //     [type]: e.target.value,
    //   });
    //   ConfigProvider.config({
    //     theme: colorState
    //   });
    //   console.log(ConfigProvider)
    // };
    // onColorChange()
    // onMounted(() => {
    //   onColorChange()
    // })
    return{
      // onColorChange,
      colorState,
      local
    }
  }
}
</script>

<style>

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  /*overflow: hidden;*/
}
</style>
